import React from "react";
import mapboxgl from 'mapbox-gl';
import {Images} from "../../../controller/Images";

import "@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css";
import {DispatchHeaderLink} from "../DispatchHeaderLink";
import {UserContext} from "../../../controller/Utils";

var MapboxGeocoder = require('@mapbox/mapbox-gl-geocoder');
var convert = require('convert-units')

mapboxgl.accessToken = "pk.eyJ1IjoibW9oaXQtY29uc29sZWJpdCIsImEiOiJjam03aGdsYWgwYjRhM3FxeG5ucHJnbWNtIn0.JPWuJuv27lM5aVzm5e7j7A";
var geocoder = new MapboxGeocoder({accessToken: mapboxgl.accessToken});


export class LiveMap extends React.Component {
  static contextType = UserContext;
  state = {
    geojson: {
      type: 'FeatureCollection',
      truck: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [-73.179320, 40.812864]
          },
          properties: {
            title: 'Mapbox',
            description: 'Washington, D.C.'
          },
          destination: {
            coordinates: [-73.1205307, 40.785]
          }
        }
      ],
      destination: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [-73.1205307, 40.785]
          },
          properties: {
            title: 'Mapbox',
            description: 'Washington, D.C.'
          }
        },
      ]
    }
  }

  componentDidMount() {
    this.map = new mapboxgl.Map({
      container: this.mapContainer,
      center: [-73.1205307, 40.785],
      style: 'mapbox://styles/mapbox/streets-v9',
      zoom: 12
    });

    this.map.addControl(geocoder);
    this.map.addControl(new mapboxgl.ScaleControl());
    this.map.addControl(new mapboxgl.NavigationControl());

    this.addTruck()
    this.addDestination()
  }

  componentWillUnmount() {
    this.map.remove();
  }

  addTruck() {
    const $this = this
    this.state.geojson.truck.forEach(function (marker) {

      var start = marker.geometry.coordinates;
      var end = marker.destination.coordinates;
      var directionsRequest = 'https://api.mapbox.com/directions/v5/mapbox/driving-traffic/' + start[0] + ',' + start[1] + ';' + end[0] + ',' + end[1] + '?geometries=geojson&access_token=' + mapboxgl.accessToken;
      fetch(directionsRequest)
        .then(data => {
          if (data.ok) {
            return data.json()
          }
        })
        .then(data => {
          var route = data.routes[0].geometry;
          $this.map.addLayer({
            id: 'route',
            type: 'line',
            source: {
              type: 'geojson',
              data: {
                type: 'Feature',
                geometry: route
              }
            },
            paint: {
              'line-width': 4,
              'line-color': '#14b838'
            }
          });
          var popup = new mapboxgl.Popup({offset: 25}).setHTML($this.getPopupText(data.routes[0]));
          var el = document.createElement('div');
          el.className = 'truck-pin';
          el.style.backgroundImage = 'url(' + Images.map_truck + ')';
          new mapboxgl.Marker(el)
            .setLngLat(marker.geometry.coordinates)
            .setPopup(popup)
            .addTo($this.map);
        })
    });
  }

  getPopupText(data) {
    const distance = convert(data.distance).from('m').toBest()
    const duration = convert(data.duration).from('s').toBest()
    return '<div className="route-popup"><p><span>Distance:</span>' + distance.val + distance.unit + '</p><p><span>Duration:</span>' + duration.val + duration.unit + '</p></div>'
  }

  addDestination() {
    const map = this.map
    this.state.geojson.destination.forEach(function (marker) {
      var el = document.createElement('div');
      el.className = 'destination-pin';
      el.style.backgroundImage = 'url(' + Images.location_pin + ')';
      new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(map);
    });
  }

  render() {
    const style = {
      width: '100%',
      height: '500px'
    };
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB Dispatch</h3>
              </div>
              <div className="col-sm-9 col-12">
                <DispatchHeaderLink user={this.context.user}/>
              </div>
            </div>
            <div className="row clearfix">
              <div style={style} ref={el => this.mapContainer = el}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/dispatch/live_map/LiveMap.jsx